import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActionButtonComponent } from './action-button/action-button.component';
import { PageTitleComponent } from './page-title/page-title.component';
import { AddMethodologyComponent } from './add-methodology/add-methodology.component';
import { AddEditModalComponent } from './add-edit-modal/add-edit-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedWithComponent } from './shared-with/shared-with.component';
import { AddEditCollaboratorsComponent } from './add-edit-collaborators/add-edit-collaborators.component';
import { AddEditDestinationsComponent } from './add-edit-destinations/add-edit-destinations.component';
import { LoaderComponent } from './loader/loader.component';
import { CollapsableWrapperComponent } from './collapsable-wrapper/collapsable-wrapper.component';
import { PowerBiComponent } from './power-bi/power-bi.component';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { PipeModule } from '../directives/pipe/pipe.module';
import { ExportModalComponent } from './export-modal/export-modal.component';
import { RestoreModalComponent } from './restore-modal/restore-modal.component';

//
import { TableComponent } from '../tools-components/table/table.component';
import { CellManualEditComponent } from '../tools-components/cell-manual-edit/cell-manual-edit.component';
import { CellDropdownComponent } from '../tools-components/cell-dropdown/cell-dropdown.component';
import { CellBooleanComponent } from '../tools-components/cell-boolean/cell-boolean.component';
import { TruncatePipe } from '../directives/truncate.pipe';
import { AddEditOrganizationModalComponent } from './add-edit-organization-modal/add-edit-organization-modal.component';
import { AddEditModalSFRComponent } from '../tools-components/add-edit-modal-SFR/add-edit-modal-SFR.component';
import { AddEditModalPNRRComponent } from '../tools-components/add-edit-modal-PNRR/add-edit-modal-PNRR.component';
import { FormPercentageInputComponent } from './form-percentage-input/form-percentage-input.component';

@NgModule({
  declarations: [
    ActionButtonComponent,
    PageTitleComponent,
    AddMethodologyComponent,
    AddEditModalComponent,
    SharedWithComponent,
    AddEditCollaboratorsComponent,
    AddEditDestinationsComponent,
    LoaderComponent,
    CollapsableWrapperComponent,
    PowerBiComponent,
    AddEditModalSFRComponent,
    AddEditModalPNRRComponent,
    ExportModalComponent,
    TableComponent,
    CellManualEditComponent,
    CellDropdownComponent,
    CellBooleanComponent,
    TruncatePipe,
    RestoreModalComponent,
    AddEditOrganizationModalComponent,
    FormPercentageInputComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    NgxPowerBiModule,
    PipeModule,
    ReactiveFormsModule
  ],
  exports: [
    ActionButtonComponent,
    PageTitleComponent,
    AddMethodologyComponent,
    AddEditModalComponent,
      SharedWithComponent,
    AddEditModalSFRComponent,
    AddEditCollaboratorsComponent,
    AddEditDestinationsComponent,
    LoaderComponent,
    CollapsableWrapperComponent,
    PowerBiComponent,
      ExportModalComponent,
      TableComponent,
      CellManualEditComponent,
      CellDropdownComponent,
      CellBooleanComponent,
      TruncatePipe,
      RestoreModalComponent,
      FormPercentageInputComponent
  ]
})

export class SharedComponentsModule { }
